module.exports = __webpack_public_path__ + "static/media/desktop.f367998.mp4";


//////////////////
// WEBPACK FOOTER
// ./src/assets/videoBg/RoundMove/desktop.mp4
// module id = jWVx
// module chunks = 1